<template>
  <div class="copyright-line">
    <h1>Copyright Line</h1>
    <div class="wrapper">
      <div class="left">
        <h2>Copyrights text</h2>
        <p>Place here text you want to see in the copyrights area.</p>
      </div>
      <div class="right">
        <textarea :value="copyrightLine" @input="$emit('copyrightLine', $event.target.value)" maxlength="255"></textarea>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    copyrightLine: {
      type: String,
    },
  },
};
</script>

<style lang='scss' scoped>
.copyright-line {
  margin: 40px 0 0 0;
  h1 {
    font-family: Roboto;
    font-style: normal;
    font-weight: bold;
    font-size: 18px;
    line-height: 21px;
    color: #001529;
    padding: 25px 0;
    border-bottom: 1px solid #cbcbe4;
  }
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    max-width: 950px;
    .left {
      h2 {
        font-family: Roboto;
        font-style: normal;
        font-weight: 500;
        font-size: 18px;
        line-height: 21px;
        color: #001529;
      }
      p {
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 16px;
        color: #001529;
      }
    }
    .right {
      textarea {
        width: 675px;
        height: 64px;
        background: #ffffff;
        border: 1px solid #dfe1e6;
        box-sizing: border-box;
        border-radius: 2px;
      }
    }
  }
}
</style>